import React from 'react';
import { createRoot } from 'react-dom/client';
import { LicenseInfo } from '@mui/x-license';
import App from './App.js';

LicenseInfo.setLicenseKey('573c2da7a3184e8a90d364ab77842b07Tz0xMTY5MDIsRT0xNzg1NDU1OTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');//TODO move into env/config file
createRoot(document.getElementById('root')).render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
